var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1042 764L1042 792",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1042.5,
    cy: 759.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.99 759.19C1037.99 755.283 1041.29 752.117 1045.36 752.117C1045.94 752.117 1046.51 752.184 1047.06 752.308C1045.74 751.48 1044.19 751 1042.52 751C1037.81 751 1034 754.806 1034 759.5C1034 764.194 1037.81 768 1042.52 768C1044.81 768 1046.89 767.093 1048.43 765.62C1047.49 766.032 1046.45 766.263 1045.36 766.263C1041.29 766.263 1037.99 763.096 1037.99 759.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.4 758.6L1051.37 756.146L1049.54 757.719L1047.3 757.056L1048.11 759.337L1046.77 761.381L1049.1 761.218L1050.5 763.144L1051.13 760.763L1053.34 759.909L1051.4 758.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.64a189b8bae3ec15da324036bf1dc4af.svg";
export { ForwardRef as ReactComponent };